import styled from "@emotion/styled";
import { Table } from "antdv5";

const ScanDetailStyledTable = styled(Table)`
  div.showTotal {
    display: flex;
    align-items: center;
  }
  .ant-pagination-total-text {
    flex-grow: 1 !important;
  }
`;

export default ScanDetailStyledTable;
